export default {"src":"/_next/static/media/facebook.e810a02d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};